import { Text } from '@nike/eds'

export interface PageSizeProps {
  currentSize: number
  changeSize: (newSize: number) => void
}

export function PageSize({ currentSize, changeSize }: PageSizeProps) {
  const PAGE_OPTIONS = [10, 20, 50, 100, 200]

  return (
    <div>
      <Text font="subtitle-1" as="span">
        Page size:
      </Text>
      <select
        id="select-page"
        style={{ margin: '16px' }}
        value={currentSize}
        onChange={(e) => changeSize(parseInt(e.target.value))}
      >
        {PAGE_OPTIONS.map((ps) => (
          <option key={ps} value={ps}>
            {ps}
          </option>
        ))}
      </select>
    </div>
  )
}
